"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookiePolicyAnalyticsMiddleware = void 0;
var constants_1 = require("../constants");
var cookiePolicyAnalyticsMiddleware = function (_a) {
    var policyGetter = _a.policyGetter;
    var segment = function (_a) {
        var _b, _c;
        var next = _a.next, payload = _a.payload;
        var _d = policyGetter(), cookie_consent = _d.cookie_consent, store = _d.store;
        var context = (_b = payload.obj.context) !== null && _b !== void 0 ? _b : {};
        var traits = (_c = context.traits) !== null && _c !== void 0 ? _c : {};
        var integrations = payload.obj.integrations ? payload.obj.integrations : {};
        traits.cookie_consent =
            cookie_consent;
        var integrationValues = {
            Everflow: true,
            'Facebook conversion API dev': true,
            'Facebook Conversions API': true,
            'Facebook Pixel': true,
            'Google Ads (Gtag': true,
            'TikTok FE': true,
            'UTM & marketing params Amplitude': true,
            'UTM & marketing params Destination': true,
            'Braze Web Mode (Actions)': true,
        };
        if (cookie_consent.profiling === 'yes') {
            integrations = integrationValues;
        }
        if (store && store === constants_1.STORE.US && cookie_consent.profiling === 'none') {
            integrations = integrationValues;
        }
        payload.obj.context = context;
        payload.obj.integrations = integrations;
        next(payload);
    };
    return {
        segment: segment,
    };
};
exports.cookiePolicyAnalyticsMiddleware = cookiePolicyAnalyticsMiddleware;
//# sourceMappingURL=cookiePolicyAnalyticsMiddleware.js.map